import axios from "axios";
import _ from "lodash";

import {findPostHelper} from '@/store/modules/helpers/helpers.js';

import {
	setComment,
	removeComment,
	getComments,
	getAnswers,
	editComment,
	setQuotedCommentContent,
} from "@/store/modules/wall/comments/commentActions";
import {
	appendCommentToPost,
	removeCommentFromPost,
	appendCommentsToPost,
	appendAnswersToComment,
	replaceCommentInPost,
} from "@/store/modules/wall/comments/commentMutations";
import {
	setReaction,
	updateReaction,
	removeReaction,
	getReactions,
} from "@/store/modules/wall/reactions/reactionsActions";
import {
	appendReactionToPost,
	appendReactionToComment,
	removeReactionFromComment,
	removeReactionFromPost,
	appendReactionToProblemIdea,
	removeReactionFromProblemIdea,
	updateReactionToProblemIdea,
	updateReactionToPost,
	updateReactionToComment
} from "@/store/modules/wall/reactions/reactionsMutations";

const state = {
	scrollCount: 0,
	singlePost: null,
	posts: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	lastBunch: [],
	seenPosts: [],
	sortBy: 'activity',
	loading: true,
	session: null,
	newPostsCount: 0,
	currentVisiblePost: null,
	isTop: false,
	savedForLater: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	problems: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	polls: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
	userPosts: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	},
};

const getters = {
	userPosts: (state) => {
		return state.userPosts.data;
	},
	userPostsMeta: (state) => {
		return state.userPosts.meta;
	},
	polls: (state) => {
		return state.polls.data;
	},
	pollsMeta: (state) => {
		return state.polls.meta;
	},
	problems: (state) => {
		return state.problems.data;
	},
	problemsMeta: (state) => {
		return state.problems.meta;
	},
	savedForLater: (state) => {
		return state.savedForLater
	},
	singlePost: (state) => {
		return state.singlePost;
	},
	loading: (state) => {
		return state.loading;
	},
	scrollCount: (state) => {
		return state.scrollCount;
	},
	posts: (state) => {
		return state.posts.data;
	},
	meta: (state) => {
		return state.posts.meta;
	},
	seenPosts: (state) => {
		return state.seenPosts;
	},
	sortBy: (state) => {
		return state.sortBy;
	},
	lastBunch: (state) => {
		return state.lastBunch;
	},
	session: (state) => {
		return state.session;
	},
	newPostsCount: (state) => {
		return state.newPostsCount;
	},
	currentVisiblePost: (state) => {
		return state.currentVisiblePost;
	},
	isTop: (state) => {
		return state.isTop;
	}
};

const mutations = {
	appendCommentToPost,
	replaceCommentInPost,
	removeCommentFromPost,
	appendCommentsToPost,
	appendAnswersToComment,
	appendReactionToPost,
	appendReactionToComment,
	removeReactionFromComment,
	removeReactionFromPost,
	appendReactionToProblemIdea,
	removeReactionFromProblemIdea,
	updateReactionToProblemIdea,
	setSinglePost(state, payload) {
		state.singlePost = payload;
	},
	setLoading(state, payload) {
		state.loading = payload;
	},
	setPage(state, payload) {
		state.posts.meta.page = payload;
	},
	setMeta(state, payload) {
		Object.keys(payload).forEach((key) => {
			state.posts.meta[key] = payload[key];
		});
	},
	setPosts(state, payload) {
		state.posts.data = payload;
	},
	setSeenPosts(state, payload) {
		state.seenPosts = payload;
	},
	addSeenPost(state, payload) {
		if (state.seenPosts.indexOf(payload) === -1) {
			state.seenPosts.push(payload);
		}
	},
	addScroll(state) {
		state.scrollCount++;
	},
	setSortBy(state, payload) {
		state.sortBy = payload;
	},
	setPost(state, payload) {
		let post = findPostHelper(state, payload.id);
		// let index = state.posts.data.findIndex(x => x.id == payload.id);
		if(post) {
			post = _.merge(post, payload);
			this._vm.$root.$emit('postUpdated', payload.id)
			return post;
		}
		return false;

		/*
		if(index != -1) {
			let n = _.merge({}, state.posts.data[index], payload)
			state.posts.data.splice(index, 1, n);
			this._vm.$root.$emit('postUpdated', payload.id)
			return state.posts.data[index];
		}
		else if(state.singlePost && state.singlePost.id == payload.id) {
			let n = _.merge({}, state.singlePost, payload);
			state.singlePost = n;
			this._vm.$root.$emit('postUpdated', payload.id)
		}
		return false;
		*/
	},
	setPostProperty(state, payload) {
		const index = state.posts.data.findIndex(x => x.id == payload.id);
		if(index != -1) {
			Object.keys(payload).forEach(key => {
				if(key != 'id') {
					state.posts.data[index][key] = payload[key];
				}
			});
		}
		else if(state.singlePost && state.singlePost.id == payload.id) {
			Object.keys(payload).forEach(key => {
				if(key != 'id') {
					state.singlePost[key] = payload[key];
				}
			});
		}
	},
	appendPost(state, payload) {
		state.posts.data.push(payload);
	},
	setLastBunch(state, payload) {
		state.lastBunch = payload;
	},
	incrementSession(state) {
		state.session++;
	},
	clearPosts(state) {
		state.posts = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			},
		};
	},
	setProblemStatus(state, payload) {
		// let index = findPostIndex(state, payload.postId);
		let post = findPostHelper(state, payload.postId);
		if(post) {
			if(post.postable && post.postable.status) {
				post.postable.status = payload.status;
				return true;
			}
		}
		return false;
	},
	setPostProblem(state, payload) {
		//let index = findPostIndex(state, payload.post_id);

		let post = findPostHelper(state, payload.post_id);
		if(post) {
			post.postable = payload;
			return true;
		}
		return false;
	},

	removePost(state, payload) {
		let index = state.posts.data.findIndex((x) => x.id == payload.id);
		if (index != -1) {
			state.posts.data.splice(index, 1);
			return true;
		}
		else if(state.singlePost && state.singlePost.id == payload.post_id) {
			state.singlePost = null;
			return true;
		}
		return false;
	},
	setPostPoll(state, payload) {
		console.log("SET POST POLL PAYLOAD:", payload)
		let post = findPostHelper(state, payload.post_id);
		if(post) {
			post.postable = payload;
			return true;
		}
		return false;
	},
	setPostPollAnswers(state, payload) {
		let post = findPostHelper(state, payload.post_id);
		if(post) {
			post.postable.poll_answers = payload.poll_answers;
			return true;
		}
		return false;
	},
	setNewPostsCount(state, payload) {
		state.newPostsCount = payload;
	},
	setCurrentVisiblePost(state, payload) {
		state.currentVisiblePost = payload
	},
	setIsTop(state, payload) {
		state.isTop = payload;
	},
	incrementNewPostsCount(state) {
		state.newPostsCount++;
	},
	updateReactionToPost,
	updateReactionToComment,
	setSavedForLater(state, payload) {
		state.savedForLater = payload;
	},
	appendSavedForLater(state, payload) {
		console.log("SHOULD APPEND", payload)
		if(state.savedForLater.data.indexOf(payload.id) == -1) {
			state.savedForLater.data.push(payload);
		}
	},
	setSavedForLaterMeta(state, payload) {
		state.savedForLater.meta = payload;
	},
	clearSavedForLater(state) {
		state.savedForLater = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			}
		}
	},
	clearProblems(state) {
		state.problems = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			}
		}
	},
	setProblems(state, payload) {
		state.problems.data = payload;
	},
	setProblemsMeta(state, payload) {
		state.problems.meta = payload;
	},
	appendProblem(state, payload) {
		if(state.problems.data.findIndex(x => x.id == payload.id) != -1) {
			state.problems.data.push(payload);
		}
	},

	clearPolls(state) {
		state.polls = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			}
		}
	},
	setPolls(state, payload) {
		state.polls.data = payload;
	},
	setPollsMeta(state, payload) {
		state.polls.meta = payload;
	},
	appendPoll(state, payload) {
		if(state.polls.data.findIndex(x => x.id == payload.id) != -1) {
			state.polls.data.push(payload);
		}
	},

	clearUserPosts(state) {
		state.userPosts = {
			data: [],
			meta: {
				// PAGINATION
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			}
		}
	},
	setUserPosts(state, payload) {
		state.userPosts.data = payload;
	},
	setUserPostsMeta(state, payload) {
		state.userPosts.meta = payload;
	},
	appendUserPost(state, payload) {
		if(state.userPosts.data.findIndex(x => x.id == payload.id) != -1) {
			state.userPosts.data.push(payload);
		}
	}
}

const actions = {
	setComment,
	getComments,
	editComment,
	removeComment,
	getAnswers,
	setReaction,
	updateReaction,
	removeReaction,
	setQuotedCommentContent,
	getReactions,
	async getPosts({ commit, state }, payload) {
		let res = {};
		let params = Object.assign({}, payload);
		params.sort_by = state.sortBy;
		commit("setLoading", true);
		await axios
			.get("posts", { params: params })
			.then((response) => {
				console.log("POSTS:", response.data);
				if (payload && payload.page && payload.page > 1) {
					response.data.data.forEach((x) => {
						commit("appendPost", x);
					});
				} else {
					commit("setPosts", response.data.data);
					commit('setNewPostsCount', 0)
				}
				commit(
					"setLastBunch",
					response.data.data.map((x) => x.id)
				);
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
				commit("setMeta", response.data.meta);
			})
			.catch((error) => {
				console.log("Get posts error", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		commit("setLoading", false);
		return res;
	},
	/*
	async getPost({commit}, id) {
		let res = {};
		await axios
			.get(`posts/${id}`)
			.then((response) => {
				const post = response.data.data;
				res = {
					success: true,
					data: post,
					error: false,
				};
			})
			.catch((error) => {
				console.log("GET POST ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	*/
	async reloadPost({ commit }, id) {
		let res = {};
		await axios
			.get(`posts/${id}`)
			.then((response) => {
				console.log("SET POST SUCCESS", response);
				const post = response.data.data;
				commit("setPost", post);
				if(post.postable) {
					console.log("HAS POSTABLE", post.postable)
					commit('setPostProperty', {id: id, postable: post.postable});
				}
				res = {
					success: true,
					data: post,
					error: false,
				};
			})
			.catch((error) => {
				console.log("SET POST ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async changeProblemStatus({ commit }, payload) {
		console.log("TO CHANGE", payload);
		let res = {};
		await axios
			.patch(`posts/problem/${payload.postId}`, {
				problem: {
					status: payload.status,
				},
			})
			.then((response) => {
				console.log("OK RESPONSE", response);
				commit("setProblemStatus", payload);
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
			})
			.catch((error) => {
				console.log("PATCH ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async deleteProblemIdea({ commit }, payload) {
		let res = {};
		await axios
			.delete(`posts/problem/idea/${payload}`)
			.then((response) => {
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
				commit("setPostProblem", response.data.data);
			})
			.catch((error) => {
				console.log("DELETE ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async editProblemIdea({ commit }, payload) {
		let res = {};
		await axios
			.patch(`posts/problem/idea/${payload.id}`, {
				content: payload.content,
				mention_user_ids: payload.mention_user_ids,
			})
			.then((response) => {
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
				commit("setPostProblem", response.data.data);
			})
			.catch((error) => {
				console.log("EDIT ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async setProblemIdeaAsSolution({ commit }, payload) {
		// api/posts/problem/idea/{problemIdea}/update-is-solution
		let res = {};
		console.log("PAYLOAD", payload);
		await axios
			.patch(`posts/problem/idea/${payload.id}/update-is-solution`, {
				is_solution: payload.is_solution,
			})
			.then((response) => {
				console.log("RESPONSE", response);
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
				commit("setPostProblem", response.data.data);
			})
			.catch((error) => {
				console.log("EDIT ERROR", error.response);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async updateProblemPost({ commit }, payload) {
		// api/posts/problem/{post}
		let res = {};
		await axios
			.patch(`posts/problem/${payload.id}`, payload)
			.then((response) => {
				console.log("RESPONSE", response);
				commit("setPost", response.data.data);
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
			})
			.catch((error) => {
				console.log("ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});

		return res;
	},
	async deletePost({ commit }, payload) {
		let res = {};
		// api/posts/{id}
		await axios
			.delete(`posts/${payload.id}`)
			.then((response) => {
				console.log("DELETE POST SUCCESS", response);
				commit("removePost", { id: payload.id });
				res = {
					success: true,
					data: response.data.data,
					error: false,
				};
			})
			.catch((error) => {
				console.log("DELETE POST ERROR", error);
				res = {
					success: false,
					data: null,
					error: error,
				};
			});
		return res;
	},
	async editPost({commit}, payload) {
		console.log("PAYLOAD", payload)
		let url = null;
		if(payload.type == 'poll') {
			url = 'posts/poll'
		}
		else if(payload.type == 'problem') {
			url = 'posts/problem'
		}
		else if(payload.type == 'kudos') {
			url = 'posts/kudos'
		}
		else {
			url = 'posts'
		}
		let res = {};
		await axios.patch(`${url}/${payload.id}`, payload.post)
			.then(response => {
				console.log("UPDATE POST SUCCESS", response)
				commit('setPost', response.data.data);
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				console.log("UPDATE POST ERROR", error.response)
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	async getSinglePost({commit}, payload) {
		let res = {};
		await axios.get('posts/' + payload.id)
			.then(response => {
				commit('setSinglePost', response.data.data);
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	async getSinglePostComment({commit}, payload) {
		let res = {};
		await axios.get('comments/' + payload.id + '/full')
			.then(response => {
				let post = {};
				post = response.data.data.post;

				let p = response.data.data;
				delete p.post;

				post.comments = [
					p
				];
				commit('setSinglePost', post);
				res = {
					success: true,
					data: post,
					error: false
				}
			})
			.catch(error => {
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	async getSavedForLater({commit}, params) {
		let res = {};
		await axios.get('saved-for-later', {
			params
		})
			.then(response => {
				console.log("SUCCESS GETTINT SAVED FOR LATER", response)
				if(params && params.page && params.page > 1) {
					response.data.data.forEach(x => {
						commit('appendSavedForLater', x);
					})
				}
				else {
					commit('setSavedForLater', response.data);
				}
				commit('setSavedForLaterMeta', response.data.meta)
				res = {
					success: true,
					data: response.data,
					error: false
				}
			})
			.catch(error => {
				console.log("ERROR GETTING SAVED FOR LATER", error)
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	/* eslint-disable */
	async saveForLater({}, payload) {
		let res = {};
		await axios.post('saved-for-later', payload)
			.then(response => {
				console.log('SUCCESS SAVING FOR LATER')
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				console.log("ERROR SAVING FOR LATER", error)
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	async deleteSavedForLater({}, payload) {
		let res = {};
		await axios.delete('saved-for-later/' + payload.id)
			.then(response => {
				console.log('SUCCESS DELETING FOR LATER')
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				console.log("ERROR DELETING FOR LATER", error)
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	},
	async getProblems({commit}, payload) {
		let res = {};
		let page = null;
		if(payload.page) {
			page = payload.page;
		}
		await axios.get(`posts`, {
			params: { page: page, postable_type: "problem" },
		})
		.then(response => {
			/*
				this.posts.push(...response.data.data);
				this.total = response.data.meta.last_page;
				this.page++;
			*/
			if(page && page > 1) {
				response.data.data.forEach(x => {
					commit('appendProblem', x);
				})
			}
			else {
				commit('setProblems', response.data.data)
			}
			commit('setProblemsMeta', response.data.meta);
			res = {
				success: true,
				data: response.data.data,
				error: false
			}
		})
		.catch(error => {
			console.log("ERROR GETTING PROBLEMS", error);
			res = {
				success: false,
				data: null,
				error: error
			}
		})
		return res;
	},

	async getPolls({commit}, payload) {
		let res = {};
		let page = null;
		if(payload.page) {
			page = payload.page;
		}
		await axios.get(`posts`, {
			params: { page: page, postable_type: "poll" },
		})
		.then(response => {
			/*
				this.posts.push(...response.data.data);
				this.total = response.data.meta.last_page;
				this.page++;
			*/
			if(page && page > 1) {
				response.data.data.forEach(x => {
					commit('appendPoll', x);
				})
			}
			else {
				commit('setPolls', response.data.data)
			}
			commit('setPollsMeta', response.data.meta);
			res = {
				success: true,
				data: response.data.data,
				error: false
			}
		})
		.catch(error => {
			console.log("ERROR GETTING POLLS", error);
			res = {
				success: false,
				data: null,
				error: error
			}
		})
		return res;
	},

	async getUserPosts({commit}, payload) {
		let res = {};
		let page = null;
		if(payload.page) {
			page = payload.page;
		}
		await axios.get(`users/posts/${payload.user_id}`, {
			params: { page: page },
		})
		.then(response => {
			/*
				this.posts.push(...response.data.data);
				this.total = response.data.meta.last_page;
				this.page++;
			*/
			if(page && page > 1) {
				response.data.data.forEach(x => {
					commit('appendUserPost', x);
				})
			}
			else {
				commit('setUserPosts', response.data.data)
			}
			commit('setUserPostsMeta', response.data.meta);
			res = {
				success: true,
				data: response.data.data,
				error: false
			}
		})
		.catch(error => {
			console.log("ERROR GETTING USER POSTS", error);
			res = {
				success: false,
				data: null,
				error: error
			}
		})
		return res;
	}
	/* eslint-enable */

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
